"use client"

import { Moon, Sun } from "lucide-react"
import { useEffect, useState } from "react"
import { useResoltoTheme } from "./theme-provider"

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useResoltoTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  if (!mounted) {
    return <span className="icon-button theme-placeholder" aria-hidden="true" />
  }

  const dark = resolvedTheme === "dark"
  return (
    <button
      type="button"
      className="icon-button"
      onClick={() => setTheme(dark ? "light" : "dark")}
      aria-label={dark ? "Use light theme" : "Use dark theme"}
      title={dark ? "Use light theme" : "Use dark theme"}
    >
      {dark ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
    </button>
  )
}
